import { render, staticRenderFns } from "./QRPreRegisterParking.vue?vue&type=template&id=5df0c8b3&scoped=true"
import script from "./QRPreRegisterParking.vue?vue&type=script&lang=js"
export * from "./QRPreRegisterParking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df0c8b3",
  null
  
)

export default component.exports